import { createContext } from "react";

export type NavigationContext = {
	openDrawer: (id: string, closeDrawer: () => void) => void;
	closeDrawer: (id: string) => void;
	back: () => void;
};

export const NavigationContext = createContext<NavigationContext | null>(null);
